import React from 'react'
import { Modal as LibModal } from 'reactstrap'
import './Modal.scss'

const Modal = (props) => {
  return <LibModal {...props}>{props.children}</LibModal>
}

export default Modal
